import { useCallback, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Search from './Search'
import ProductHeader from './ProductHeader'
import Bread from './Bread'
import styles from '@/layouts/style.module.less'
import logoIcon from '@/assets/images/layouts/logo.png'
import userIcon from '@/assets/images/layouts/user.png'

const Head = () => {
  const location = useLocation()
  const navigator = useNavigate()
  const [menus] = useState([
    {
      label: 'PRODUCTS',
      children: <ProductHeader />,
      menuType: 'large'
    }, {
      label: 'FIND A STORE',
      href: '/dealer/distributor'
    }, {
      label: 'NEWS',
      href: '/news'
    }, {
      label: 'SUPPORT',
      menuType: 'dropdown',
      items: [
        {
          label: 'DOWNLOAD',
          href: '/support'
        }, {
          label: 'CONTACT US',
          href: '/contactus'
        }
      ]
    }, {
      label: 'ABOUT US',
      menuType: 'dropdown',
      items: [
        {
          label: 'BRAND STORY',
          href: '/aboutus/companyoverview',
        }, {
          label: 'TEAM',
          href: '/aboutus/team',
        }, {
          label: 'TECHNOLOGY',
          href: '/aboutus/technology',
        }, {
          label: 'MEDELI PARK',
          href: '/aboutus/medelipark',
        }
      ]
    }
  ])

  // 跳转
  const handleNav = useCallback((menu) => {
    if(menu.href) {
      navigator(menu.href)
    }
  }, [navigator])

  return (
    <div className={location.pathname === '/' && styles.head}>
      <div className={styles['head-container']}>
        <div className='layout-container h-full'>
          <div className='flex text-white align-center h-full relative'>
            <Bread />
            <a href='/'>
            <img src={logoIcon} alt='' className='h-full cursor-pointer'  />
            </a>
            <div className='flex-1'></div>
            {
              menus.map(menu => (
                <div className={`${styles['menu-item']}`} onClick={() => handleNav(menu)} key={menu.label}>
                  <span>{menu.label}</span>
                  {
                    menu.children && menu.menuType === 'large' && (
                      <div className={styles['menu-sub']}>
                        { menu.children }
                      </div>
                    )
                  }
                  {
                    menu.menuType === 'dropdown' && (
                      <div className={styles['menu-dropdown']}>
                        {
                          menu.items.map(item => (
                            <div className={styles['menu-dropdown-item']} onClick={() => handleNav(item)}>{item.label}</div>
                          ))
                        }
                      </div>
                    )
                  }
                </div>
              ))
            }
            <Search calssName='ml-20' />
            <div className='ml-30'>
              {/* <img src={userIcon} alt=''  className={styles['head-user']} /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Head
